module.exports = __webpack_public_path__ + "img/GRD.fcbfb01f.svg";